import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'sim-modal-header',
    templateUrl: './modal-header.component.html',
    styleUrls: ['./modal-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ModalHeaderComponent {
  @Input() darkMode: boolean = false;
  @Input() headerTitle: string = '';
}
